import { useContext } from 'react';

import { TabulusContext } from '@tabulus/contexts';

const useTabulusContext = () => useContext(TabulusContext);

export { useTabulusContext };
